import { TextField, makeStyles,Checkbox } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import UserRoleTable from './UserRoleTable';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import clsx from 'clsx';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { dataService } from '../../../Services/data.service';
import { applicationIds } from '../../../Config/constants';

export default function UserCrudForm(props) {

    const classes = useStyles();
    const [overwritePassword, setOverwritePassword] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [repeatedPassword, setRepeatedPassword] = useState("");
    const [userName, setUserName] = useState("");
    const [familyName, setFamilyName] = useState("");
    const [givenName, setGivenName] = useState("");
    const [email, setEmail] = useState("");
    const [roles, setRoles] = useState([]);

    const [userNameErrorText, setUserNameErrorText] = useState(null);
    const [givenNameErrorText, setGivenNameErrorText] = useState(null);
    const [familyNameErrorText, setFamilyNameErrorText] = useState(null);
    const [emailErrorText, setEmailErrorText] = useState(null);
    const [newPasswordErrorText, setNewPasswordErrorText] = useState(null);
    const [repeatedPasswordErrorText, setRepeatedPasswordErrorText] = useState(null);

    const changeOverwritePassword = () => {
        if (overwritePassword) {
            setNewPassword("");
            setRepeatedPassword("");
        }

        setOverwritePassword(!overwritePassword);
    }

    useEffect(() => {
        if (props.userToEdit) {
            setRoles(props.userToEdit.roles);
            setUserName(props.userToEdit.loginName);
            setFamilyName(props.userToEdit.lastName);
            setGivenName(props.userToEdit.firstName);
            setEmail(props.userToEdit.email);
        }

    }, [props.open]);

    const validate = () => {

        var Ok = true;
        if (!userName || userName === "") {
            setUserNameErrorText("Gelieve een gebruikersnaam in te vullen!");
            Ok = false;
        }
        else {
            setUserNameErrorText(null);
        }
        if (!familyName || familyName === "") {
            setFamilyNameErrorText("Gelieve een familienaam in te vullen!");
            Ok = false;
        }
        else {
            setFamilyNameErrorText(null);
        }
        if (!givenName || givenName === "") {
            setGivenNameErrorText("Gelieve een voornaam in te vullen!");
            Ok = false;
        }
        else {
            setGivenNameErrorText(null);
        }
        if (!email || email === "") {
            setEmailErrorText("Gelieve een email in te vullen!");
            Ok = false;
        }
        else {
            setEmailErrorText(null);
        }
        if(props.create || overwritePassword){
            if (!newPassword || newPassword === "") {
                setNewPasswordErrorText("Gelieve een nieuw wachtwoord in te vullen!");
                Ok = false;
            }
            else {
                setNewPasswordErrorText(null);
            }
            if (!repeatedPassword || repeatedPassword === "") {
                setRepeatedPasswordErrorText("Gelieve het nieuwe wachtwoord te herhalen!");
                Ok = false;
            }
            else {
                setRepeatedPasswordErrorText(null);
            }
        }        

        if (newPassword) {
            if (newPassword !== repeatedPassword) {
                setRepeatedPasswordErrorText("Wachtwoorden komen niet overeen!");
                Ok = false;
            }
        }

        return Ok;
    }

    const confirmUser = () => {
        if (validate()) {
            var userModel = {
                Id: props.create? 0:props.userToEdit.id, 
                LoginName: userName,
                FirstName: givenName,
                LastName: familyName,
                Password: newPassword,
                OverwritePassword: overwritePassword,
                Email: email,
                Roles: roles.map(x => ({
                    RoleId: x.id ? x.id:x.roleId,
                    ApplicationId: applicationIds.SMARTPRODUCTION,
                    Name: x.name
                }))
            };

            dataService.saveUser(userModel).then(() => {
                props.refresh();
            });

            props.closeDrawer();
        }
    }

    const changeEmail = (event) => {
        setEmail(event.target.value);
        if (event.target.value !== "") {
            setEmailErrorText(null);
        }
    }

    const changeNewPassword = (event) => {
        setNewPassword(event.target.value);
        if (event.target.value !== "") {
            setNewPasswordErrorText(null);
        }
    }

    const changeRepeatedPassword = (event) => {
        setRepeatedPassword(event.target.value);
        if (event.target.value !== "") {
            setRepeatedPasswordErrorText(null);
        }
    }

    const changeUserName = (event) => {
        setUserName(event.target.value);
        if (event.target.value !== "") {
            setUserNameErrorText(null);
        }
    }

    const changeGivenName = (event) => {
        setGivenName(event.target.value);
        if (event.target.value !== "") {
            setGivenNameErrorText(null);
        }
    }

    const changeFamilyName = (event) => {
        setFamilyName(event.target.value);
        if (event.target.value !== "") {
            setFamilyNameErrorText(null);
        }
    }

    const addRole = (roleId) => {
        let tempRoles = [...roles];
        if (!tempRoles.some(x => x.id === roleId)) {
            tempRoles.push(props.roles.find(x => x.id === roleId));
        }
        setRoles(tempRoles);
    }
    const deleteRole = (roleId) => {
        let tempRoles = [...roles];
        let index = tempRoles.indexOf(tempRoles.find(x => x.id === roleId));
        tempRoles.splice(index, 1);
        setRoles(tempRoles);
    }

    return (
        <div className={classes.container}>
            <div className={classes.field}>
                <div className={classes.label}>Gebruikersnaam:</div>
                <TextField id="outlined-search" name="name" label="" type="search" variant="outlined" className={classes.formikTextField} value={userName} size="small" error={userNameErrorText} helperText={userNameErrorText} onChange={(e) => changeUserName(e)} />
            </div>
            <div className={classes.field}>
                <div className={classes.label}>Voornaam:</div>
                <TextField id="outlined-search" name="givenName" label="" type="search" variant="outlined" className={classes.formikTextField} value={givenName} size="small" error={givenNameErrorText} helperText={givenNameErrorText} onChange={(e) => changeGivenName(e)} />
            </div>
            <div className={classes.field}>
                <div className={classes.label}>Familienaam:</div>
                <TextField id="outlined-search" name="givenName" label="" type="search" variant="outlined" className={classes.formikTextField} value={familyName} size="small" error={familyNameErrorText} helperText={familyNameErrorText} onChange={(e) => changeFamilyName(e)} />
            </div>
            <div className={classes.field}>
                <div className={classes.label}>Email:</div>
                <TextField id="outlined-search" name="email" label="" type="email" variant="outlined" className={classes.formikTextField} value={email} size="small" error={emailErrorText} helperText={emailErrorText} onChange={(e) => changeEmail(e)} />
            </div>
            {!props.create && <div className={classes.field}>
                <div className={classes.label}>Wachtwoord overschrijven:</div>
                <Checkbox
                    className={classes.checkBox}
                    disableRipple
                    color="default"
                    checked={overwritePassword}
                    onClick={() => changeOverwritePassword()}
                    checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                    icon={<span className={classes.icon} />}
                    inputProps={{ 'aria-label': 'decorative checkbox' }}
                />
            </div>}
            {(overwritePassword || props.create) &&
                <React.Fragment>
                    <ToastContainer></ToastContainer>
                    <div className={classes.field}>
                        <div className={classes.label}>Nieuw wachtwoord:</div>
                        <TextField id="outlined-search" name="newPassword" label="" type="password" variant="outlined" value={newPassword} className={classes.formikTextField} size="small" error={newPasswordErrorText} helperText={newPasswordErrorText} onChange={(e) => changeNewPassword(e)} />
                    </div>
                    <div className={classes.field}>
                        <div className={classes.label}>Herhaal nieuw wachtwoord:</div>
                        <TextField id="outlined-search" name="repeatedPassword" label="" type="password" variant="outlined" value={repeatedPassword} className={classes.formikTextField} size="small" error={repeatedPasswordErrorText} helperText={repeatedPasswordErrorText} onChange={(e) => changeRepeatedPassword(e)} />
                    </div>
                </React.Fragment>
            }
            <div className={classes.field}>
                <div className={classes.label} style={{ paddingTop: roles.length > 0 ? "30px" : "0px" }}>Rollen:</div>
                <UserRoleTable addRole={addRole} deleteRole={deleteRole} roles={roles} allRoles={props.roles}></UserRoleTable>
            </div>
            <div className={classes.comfirmContainer}>
                <button className={classes.comfirmButton} onClick={() => confirmUser()}>{props.create ? "TOEVOEGEN" : "UPDATEN"}</button>
            </div>
        </div>
    )
}

const useStyles = makeStyles({

    title: {
        fontSize: "18px",
        fontWeight: 'bold',
        height: "60px"
    },
    backButton: {
        float: "right",
        outline: "none",
        border: "1px solid #E8E8E8",
        cursor: "pointer",
        backgroundColor: "white",
        fontSize: "14px",
        borderRadius: "5px",
        height: "25px"
    },
    formikTextField: {
        width: "60%",
        backgroundColor: "white",
        marginBottom: "10px",
        "& p": {
            height: "0px !important",
            marginTop: "0px !important"
        }
    },
    label: {
        float: "left",
        width: "40%",
        marginTop: "10px"
    },
    saveButtonContainer: {
        width: "100%",
        marginTop: "40px",
        textAlign: "center"
    },
    saveButton: {
        backgroundColor: "black",
        color: "white",
        borderRadius: "5px",
        border: "none",
        cursor: "pointer"
    },
    checkBox: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        float: "left",
        cursor:"pointer",
        marginTop: "5px",
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: "black",
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: "black",
        },
    },
    field: {
        width: "100%",
        minHeight: "60px",
        height: "auto",
    },
    formikSelectField: {
        width: "50%",
        height: "40px",
        borderRadius: "5px",
        backgroundColor: "white",
        border: "1px solid #c1c2be",
        paddingLeft: "10px",
        "& .MuiInput-root": {
            height: "40px",
        },
        "& .MuiInput-underline:before": {
            borderBottom: "none !important"
        },
        "& .MuiInput-underline:after": {
            borderBottom: "none !important"
        },
        "& .MuiFormHelperText-root.Mui-error": {
            marginTop: "10px",
            height: "20px",
            backgroundColor: "white",
            display: 'block'
        },
        marginBottom: "10px"
    },
    buttonContainer: {
        float: "right",
        width: "300px"
    },
    backIcon: {
        height: "15px",
        width: "15px",
        marginBottom: "2px"
    },
    backText: {
        float: "right",
        marginLeft: "5px"
    },
    container: {
        padding: "20px",
        paddingLeft: "0px"
    },
    uploadFileButton: {
        backgroundColor: "white",
        marginLeft: "10px",
        marginTop: "2px",
        width: "20px",
        minWidth: "0px !important"
    },
    imageContainer: {
        textAlign: "center",
    },
    userProfileImage: {
        maxWidth: "720px",
    },
    comfirmContainer: {
        position: "absolute",
        width: "95%",
        bottom: "20",
        textAlign: "center"
    },
    comfirmButton: {
        width: "30%",
        height: "40px",
        borderRadius: "5px",
        outline: "none",
        border: "none",
        cursor: "pointer",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        color: "white",
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",

    }

});

